import React, { useEffect } from "react";
import styled, { keyframes } from "styled-components";
import HeaderSimple from "../components/layout/HeaderSimple";
import HeroSectionSimple from "../components/sections/HeroSectionSimple";
import FooterSimple from "../components/layout/FooterSimple";
import { initAnalytics, trackPageView } from "../utils/analytics";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  margin: 0;
  padding: 0;
  color: #fff;
  background: #000;
  min-height: 100vh;
`;

const Section = styled.section`
  padding: 80px 20px;
  max-width: 1200px;
  margin: 0 auto;
  animation: ${fadeIn} 0.8s ease-out;
  text-align: center;

  h2 {
    color: #667eea;
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 40px;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 3px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 2px;
    }

    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }

  p {
    line-height: 1.6;
    font-size: 1.2rem;
    margin-bottom: 30px;
    color: #555;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-top: 60px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const FeatureCard = styled.div`
  background: #f8f9fa;
  padding: 40px 30px;
  border-radius: 20px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(103, 126, 234, 0.1);
    border-color: rgba(103, 126, 234, 0.2);
  }

  .icon {
    font-size: 3rem;
    margin-bottom: 20px;
    display: block;
  }

  h3 {
    color: #333;
    font-size: 1.4rem;
    margin-bottom: 15px;
    font-weight: 600;
  }

  p {
    color: #666;
    font-size: 1rem;
    line-height: 1.5;
    margin: 0;
  }
`;

const LoginCTASection = styled.div`
  background: #dc2626;
  color: white;
  padding: 80px 20px;
  text-align: center;
  border-radius: 20px;
  margin: 60px 20px;
  border: 2px solid rgba(220, 38, 38, 0.5);

  h2 {
    color: white;
    font-size: 2.5rem;
    margin-bottom: 20px;

    &::after {
      background: rgba(255, 255, 255, 0.3);
    }
  }

  p {
    font-size: 1.2rem;
    margin-bottom: 40px;
    opacity: 0.9;
  }
`;

const LoginButton = styled.button`
  background: rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.8);
  color: white;
  padding: 18px 40px;
  border-radius: 50px;
  font-size: 1.3rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);

  &:hover {
    background: rgba(0, 0, 0, 0.5);
    border-color: white;
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(220, 38, 38, 0.4);
  }
`;

function HomeSimple() {
  useEffect(() => {
    // Initialize analytics on page load
    initAnalytics();
    trackPageView("Landing Page Simple", {
      page_type: "landing_simple",
      user_type: "visitor",
    });
  }, []);

  const handleLogin = () => {
    window.location.href = "/login";
  };

  return (
    <Container>
      <HeaderSimple />
      <HeroSectionSimple />

      {/* Call to Action para Login */}
      <LoginCTASection>
        <h2>Acesse a plataforma</h2>
        <p>
          Faça login para acessar o Quick Check
        </p>
        <LoginButton onClick={handleLogin}>
          Fazer Login
        </LoginButton>
      </LoginCTASection>

      <FooterSimple />
    </Container>
  );
}

export default HomeSimple;